import classNames from "classnames";
import _ from "lodash";
import pluralize from "pluralize";
import qs from "query-string";
import React from "react";
import { RouteComponentProps, withRouter } from "react-router";
import {
  Button,
  Divider,
  Form,
  Message,
  Modal,
  Nav,
  Notification,
  Panel,
  Placeholder,
  Popover,
  toaster,
  Toggle,
  Whisper,
} from "rsuite";
import { UserContext } from "../components/authProvider/main";
import { RolePermissions, UserPermission } from "../core/enums/RolePermissions";
import { Event } from "../events/Event";
import * as Events from "../events/EventHolder";
import axios from "./../utilities/axios";
import { Conditionizer } from "./Conditionizer";
import { ErrorPopover } from "./errorPopover/main";
import { AxiosCascadePicker } from "./formfields/AxiosCascadePicker";
import { AxiosSelectPicker } from "./formfields/AxiosSelectPicker";
import { CheckTreePicker } from "./formfields/CheckTreePicker";
import { ColorPicker } from "./formfields/ColorPicker";
import CustomComponents from "./formfields/custom/CustomList";
import { DatePickerComponent } from "./formfields/DatePicker";
import { DayPicker } from "./formfields/DayPicker";
import { DynamicTree } from "./formfields/DynamicTree";
import { FileInput } from "./formfields/FileInput";
import { Grid } from "./formfields/Grid";
import { ListInput } from "./formfields/ListInput";
import { MaskInput } from "./formfields/MaskInput";
import { NumberInput } from "./formfields/NumberInput";
import { WYSIWYG } from "./formfields/WYSIWYG";
import { Permission } from "./Permission";
import iziToast from "izitoast";

interface IField {
  width?: number;
  type?: string;
  order?: number;
  name: string;
  label?: string;
  minlength?: number;
  regex?: string;
  maxlength?: number;
  required?: boolean;
  mask?: string[];
}

interface IFormalize {
  form: any;
  values?: any;
  history?: any;
  name: string;
  onDirty?: Function;
  errors?: any;
  isEdit?: boolean;
  submitButton?: any;
  cache?: any;
  match?: any;
  readOnly?: boolean;
  parentValues?: any;
  isModal?: boolean;
  onSubmit?: Function;
  [key: string]: any;
}

let particularitieAdd: boolean = false;
let exceptionParticularitie: boolean = false;
let particularitieEdit: boolean = false;
class Formalize extends React.Component<RouteComponentProps<any> & IFormalize, {}> {
  static contextType?: React.Context<any> | undefined = UserContext;
  public state: any = {
    oldValues: this.props.values ? this.props.values : {},
    formValues: this.props.values ?? {},
    resultValues: {},
    fieldsToUpdate: {},
    errors: this.props.errors ? this.props.errors : {},
    formData: {},
    originalForm: this.props.form,
    crud: this.props.form?.$GLOBALS?.table,
    loadings: [],
    guid: null,
    cachedData: this.props.cache ?? {},
    fieldStates: {},
    priorityFormData: {},
    totalFieldsPerTab: {},
    customTabs: [],
    hasBooted: false,
    isFormDirty: false,
    debugMode: false,
    activeTab: null,
    isLoading: true,
    tabsLoaded: ["Main"],
  };

  public uses: any = {};

  public genericEventHandler: any | Event = null;

  public instanced = false;
  public totalFieldsPerTab: any = {};
  public latestFields: any = {};

  addTab = (tabKey: string, tabLabel: string, jsxComponent: any) => {
    this.setState({
      customTabs: [
        ...this.state.customTabs,
        {
          key: tabKey,
          label: tabLabel,
          jsxComponent: jsxComponent,
        },
      ],
    });
  };

  buildFields = (
    rebuildFields: any = [],
    newValues: any = {},
    priorityForm: any = {}
  ) => {
    var newForm: any = {};
    var totalFieldsPerTab: any = {};
    var $GLOBALS = this.props.form.$GLOBALS;

    this.setState({ isLoading: true });
    if (rebuildFields.length) {
      for (var indRebuild in rebuildFields) {
        var entranceField = this.props.form[rebuildFields[indRebuild]];
        if (entranceField && entranceField.name) {
          let field = Conditionizer.set(this.props.form).getProps(
            entranceField.name,
            { ...this.state.oldValues, ...this.state.formValues, ...newValues }
          );
          if (
            field.tabs !== null &&
            field.tabs !== undefined &&
            !field.tabs.includes(this.state.activeTab)
          ) {
          }

          newForm[field.name] = field;
        }
      }
      var mergedForm = { ...this.props.form, ...newForm };
      for (var indMergForm in mergedForm) {
        if (indMergForm !== "$GLOBALS") {
          let field = mergedForm[indMergForm];
          if (field.canAdd === false && this.props.isEdit === false) {
            continue;
          }
          if (field.hidden !== true) {
            for (var tabIndex in field.tabs) {
              if (!totalFieldsPerTab[field.tabs[tabIndex]]) {
                totalFieldsPerTab[field.tabs[tabIndex]] = [];
              }
              totalFieldsPerTab[field.tabs[tabIndex]].push(field.name);
              break;
            }
          }
        }
      }
      var formData = { ...mergedForm, ...newForm };
      /*if(customSettings && customSettings.rules && customSettings.rules.fields) {
                for(var ruleFieldName in customSettings.rules.fields) {
                    if(typeof customSettings.rules.fields[ruleFieldName] === 'function') {
                        formData[ruleFieldName] = customSettings.rules.fields[ruleFieldName](formData[ruleFieldName],formValues[ruleFieldName],{ ...this.state.formValues });
                    }
                }
            }*/
      var formValues = { ...this.state.formValues };
      for (var i in newValues) {
        formValues[i] = newValues[i];
      }
      this.setState({
        formValues,
        formData,
        totalFieldsPerTab: totalFieldsPerTab,
      });
    } else {
      var { tab } = qs.parse(this.props.history.location.search);
      for (let i in this.props.form) {
        if (i !== "$GLOBALS") {
          let entranceField = this.props.form[i];
          if (!entranceField) continue;
          if (!entranceField.name) {
            continue;
          }

          let field = Conditionizer.set(this.props.form).getProps(
            entranceField.name,
            { ...this.state.oldValues, ...this.state.formValues }
          );
          if (
            field.canAdd === false &&
            this.props.isEdit === false &&
            this.props.readOnly === false
          ) {
            continue;
          }
          newForm[field.name] = field;
          if (!this.uses[field.name]) {
            this.uses[field.name] = [];
          }
          for (var cond in field.conditions) {
            var condition = field.conditions[cond];
            if (condition.query) {
              let uses: any = _.uniq(
                _.flatten(
                  Object.values(condition.query).map((item: any) => {
                    return item
                      ? Object.values(item).map((subitem: any) => {
                        return Object.keys(subitem)[0];
                      })
                      : undefined;
                  })
                )
              );
              this.uses[field.name] = [...this.uses[field.name], ...uses];
            }
            if (condition.cases) {
              let uses: any = [];
              for (var cases of condition.cases) {
                if (!uses.includes(cases.field)) {
                  uses.push(cases.field);
                }
              }
              this.uses[field.name] = [...this.uses[field.name], ...uses];
            }

            this.uses[field.name] = _.uniq(this.uses[field.name]);
          }
          if (field.hidden !== true) {
            for (let tabIndex in field.tabs) {
              if (!totalFieldsPerTab[field.tabs[tabIndex]]) {
                totalFieldsPerTab[field.tabs[tabIndex]] = [];
              }
              totalFieldsPerTab[field.tabs[tabIndex]].push(field.name);
              break;
            }
          }
        }
      }
      var activeTab: string = tab ? tab : this.state.activeTab;
      if (
        $GLOBALS &&
        $GLOBALS.tabs &&
        $GLOBALS.tabs.length &&
        (activeTab === null ||
          !Object.keys(totalFieldsPerTab).includes(activeTab)) &&
        $GLOBALS.tabs[0]
      ) {
        activeTab = $GLOBALS.tabs[0].key;
      }

      const conjoinedNewForm = newForm;

      for (var fieldName in priorityForm) {
        var field = priorityForm[fieldName];
        for (var prop in field) {
          if (!conjoinedNewForm[fieldName]) {
            conjoinedNewForm[fieldName] = {};
          }
          conjoinedNewForm[fieldName][prop] = field[prop];
        }
      }

      var updatedState: any = {
        formData: conjoinedNewForm,
        isLoading: false,
        totalFieldsPerTab,
        activeTab,
      };
      /*if(this.state.activeTab) {
                delete updatedState.activeTab;
            }*/
      this.setState(updatedState);
    }
    const eventName =
      _.upperFirst(pluralize.singular(_.camelCase(this.state.crud))) + "Events";
    const eventHolder: any = Events;

    if (eventHolder[eventName]) {
      const event = eventHolder[eventName];
      const instancedEvent = new event(
        null,
        this.state,
        this.setStateProperty,
        this.setFieldState,
        this.setExternalFieldValue,
        this.setFieldProperty,
        this.props.history,
        this.props.match,
        this.props,
        this.addTab,
        this.props.userContext?.data ? this.props.userContext.data : {}
      );
      if (this.state.hasBooted === false) {
        if (!this.props.isEdit) {
          if (instancedEvent["onInit"]) {
            instancedEvent["onInit"](this.props.parentValues);
          }
        }
        if (instancedEvent["onLoad"]) {
          instancedEvent["onLoad"]();
        }
      }

      this.genericEventHandler = instancedEvent;
    }
    if (this.state.hasBooted === false) {
      this.setState({ hasBooted: true });
    }
  };

  async componentDidMount() {
    this.buildFields();
    this.setState({ guid: this.guid });

    if (this.props.isEdit === false) {
      const settingsName =
        _.upperFirst(pluralize.singular(this.state.crud)) + "Settings";
      const events: any = Events;
      const eventClass = events[settingsName];
      if (eventClass) {
        const { defaults } = eventClass;
        for (const defaultFieldName in defaults) {
          const defaultValue = defaults[defaultFieldName];
          const field = this.props.form[defaultFieldName];
          if (field) {
            switch (field.type) {
              case "select":
                this.setStateFieldValue(defaultFieldName, defaultValue);
                break;
            }
          }
        }
      }
    }
  }

  renderFields = () => {
    const formLayout: any = this.state.formData;
    var output = [];
    if (formLayout) {
      var orderedFormLayout: any = Object.values(formLayout).sort(
        (a: any, b: any) => {
          return a.order < b.order ? -1 : 1;
        }
      );

      for (var i in orderedFormLayout) {
        if (
          orderedFormLayout[i] !== undefined &&
          orderedFormLayout[i] !== null
        ) {
          var field: IField = orderedFormLayout[i];
          if (field.name === "$GLOBALS") continue;
          var resultField = this.renderEachFieldType(field, i);
          output.push(resultField);
        }
      }
    }
    return output;
  };

  renderField = (
    field: IField,
    index: string,
    isLastField: boolean = false
  ) => {
    return this.renderEachFieldType(field, index);
  };

  public _loadedOldValues = false;
  public _forceUpdate = false;
  public hasChanged: string[] = [];

  checkGenericEvent = (eventName: string, fieldName: string) => {
    if (this.genericEventHandler?.onEvents) {
      if (this.genericEventHandler?.onEvents[eventName]) {
        if (
          this.genericEventHandler?.onEvents[eventName].listeners?.includes(
            fieldName
          )
        ) {
          const action = this.genericEventHandler?.onEvents[eventName].action;
          return this.genericEventHandler[action];
        }
      }
    }
    return null;
  };

  shouldComponentUpdate = (props: any, state: any) => {
    var shouldUpdate = false;

    if (this.state.fieldStates !== state.fieldStates) {
      shouldUpdate = true;
    }
    if (this.state.customTabs !== state.customTabs) {
      shouldUpdate = true;
    }
    if (this.state.debugMode !== state.debugMode) {
      shouldUpdate = true;
    }

    if (this.state.isFormDirty !== state.isFormDirty) {
      shouldUpdate = true;
    }

    if (!_.isEqual(this.props.errors, props.errors)) {
      this.setState({ errors: props.errors });

      shouldUpdate = true;
    }
    var shouldUpdateFields = false;
    if (this.state.priorityFormData !== state.priorityFormData) {
      shouldUpdate = true;
      shouldUpdateFields = true;
    }

    if (!_.isEqual(this.state.cachedData, state.cachedData)) {
      shouldUpdate = true;
    }
    if (!_.isEqual(this.state.formData, state.formData)) {
      shouldUpdate = true;
    }
    if (!_.isEqual(this.state.errors, state.errors)) {
      shouldUpdateFields = true;
      shouldUpdate = true;
    }
    if (
      Object.keys(this.state.totalFieldsPerTab).length !==
      Object.keys(state.totalFieldsPerTab).length
    )
      shouldUpdate = true;
    if (
      Object.keys(this.state.oldValues).length !==
      Object.keys(state.oldValues).length
    )
      shouldUpdate = true;
    if (!_.isEqual(this.props.form, props.form)) {
      shouldUpdate = true;
      shouldUpdateFields = true;
      this.setState({ isLoading: true });
    }
    if (this.state.activeTab !== state.activeTab) shouldUpdate = true;
    if (this.state.loadings !== state.loadings) {
      shouldUpdate = true;
      shouldUpdateFields = true;
    }
    if (this.state.isLoading !== state.isLoading) shouldUpdate = true;

    if (!_.isEqual(state.formValues, props.values)) {
      shouldUpdate = true;
    }
    if (!_.isEqual(this.props.parentValues, props.parentValues)) {
      shouldUpdate = true;
    }
    if (!_.isEqual(this.props.location, props.location)) {
      shouldUpdate = true;
    }

    var fieldsNeedToRebuild: string[] = [];

    var differenceFields: any = this.lastChangedInput;

    if (differenceFields !== undefined) {
      let uses = [];

      for (var k in this.uses) {
        if (this.uses[k].includes(differenceFields.field)) {
          uses.push(k);
        }
      }
      if (uses.length > 0) {
        shouldUpdateFields = true;
        shouldUpdate = true;
      }

      this.lastChangedInput = undefined;
    }
    if (shouldUpdateFields || this._forceUpdate === true) {
      if (this._forceUpdate === true) {
        shouldUpdate = true;
      }
      this.buildFields(
        this._forceUpdate === true ? [] : fieldsNeedToRebuild,
        state.formValues,
        state.priorityFormData
      );
      this._forceUpdate = false;
      this.hasChanged = [];
    }

    if (shouldUpdate) {
    }
    return shouldUpdate;
  };

  public lastChangedInput: any = {};
  public fieldCache: any = {};

  setExternalFieldValue = (field: string, fieldValue: any) => {
    this._forceUpdate = true;
    if (field) {
      var cachedData = this.state.cachedData;

      if (typeof fieldValue === "object") {
        cachedData[field] = [fieldValue];
      } else {
        cachedData[field] = fieldValue;
      }
      this.setState({ cachedData });
    }

    this.setStateFieldValue(field, fieldValue, true);
  };

  setStateProperty = (fieldOrState: string | object, value: any = null) => {
    this._forceUpdate = true;
    if (value === null || typeof fieldOrState === "object") {
      this.setState(fieldOrState);
    } else {
      var obj: any = {};
      obj[fieldOrState] = value;
      this.setState(obj);
    }
  };

  setStateFieldValue = (field: string, fieldValue: any, external = false) => {
    if (this.state.formValues[field] !== fieldValue) {
      this._forceUpdate = true;
      this.lastChangedInput = { field, fieldValue };

      var lastValues = this.state.formValues;
      if (
        fieldValue !== undefined &&
        fieldValue !== null &&
        typeof fieldValue === "string" &&
        this.state.formData[field] !== undefined &&
        this.state.formData[field].allowLowercase === undefined &&
        this.state.formData[field].type !== "custom" &&
        this.state.formData[field].type !== "richtextbox"
      ) {
        fieldValue = fieldValue.toLocaleUpperCase();
      }
      lastValues[field] = fieldValue;
      this.setState({ formValues: lastValues });
      this.setState((value: any) => {
        var errors = { ...value.errors };
        if (Object.keys(errors).includes(field)) {
          delete errors[field];
        }
        return { errors };
      });
    }
  };

  public cachedData: any = {};

  onChangeInput = (
    inputValue: any,
    name: string,
    cacheData: any = [],
    userAction = true
  ) => {
    if (cacheData) {
      var cachedData = this.state.cachedData;
      cachedData[name] = cacheData;
      this.setState({ cachedData });
    }
    if (typeof inputValue === "string" && inputValue.length > 0 && userAction) {
      if (inputValue !== this.state.oldValues[name]) {
        if (this.props.onDirty) {
          this.props.onDirty(name);
        }
        this.setState({ isFormDirty: true });
      }
    }
    this.setStateFieldValue(name, inputValue);
  };

  setFieldState = (fieldName: string, value: any) => {
    this._forceUpdate = true;

    this.setState((oldState: any) => {
      var fieldStates = oldState.fieldStates;
      var oldFieldState = fieldStates[fieldName];
      if (!oldFieldState) {
        oldFieldState = {};
      }
      oldFieldState = value;
      fieldStates[fieldName] = oldFieldState;
      return { fieldStates };
    });
  };

  renderError = (fieldName: string) => {
    if (Object.keys(this.state.errors).includes(fieldName)) {
      return (
        <Form.ErrorMessage show={true} placement={"bottomEnd"}>
          <span
            dangerouslySetInnerHTML={{ __html: this.state.errors[fieldName] }}
          ></span>
        </Form.ErrorMessage>
      );
    }
    return null;
  };

  setFieldProperty = (field: string, property: string, value: any) => {
    this.setState((oldState: any) => {
      var priorityFormData = { ...oldState.priorityFormData };
      if (!priorityFormData[field]) {
        priorityFormData[field] = {};
      }
      priorityFormData[field][property] = value;
      return { priorityFormData };
    });
  };

  public lowestTextInputIndex = 1000;

  renderEachFieldType = (field: any, index: any) => {
    var entranceField = field;
    var type = field.type;
    var hidden: any = false;
    const tabs = this.props.form.$GLOBALS ? this.props.form.$GLOBALS.tabs : [];
    var defaultValue: any =
      this.state.oldValues[entranceField.name] !== undefined
        ? this.state.oldValues[entranceField.name]
        : undefined;

    if (
      field.hidden === true ||
      (this.props.isEdit === true && field.canEdit !== true) ||
      (this.props.readOnly === true && field.canRead !== true)
    ) {
      hidden = true;
    }
    if (
      hidden === false &&
      field.tabs !== null &&
      field.tabs !== undefined &&
      !field.tabs.includes(this.state.activeTab) &&
      tabs &&
      tabs.length > 0
    ) {
      hidden = true;
    }
    if (hidden) {
      return null;
    }

    if (index < this.lowestTextInputIndex && type === "text") {
      this.lowestTextInputIndex = index;
    }

    var oldValue: any = this.state.formValues[entranceField.name];
    if (defaultValue === undefined && field.default !== undefined) {
      defaultValue = field.default;
      this.onChangeInput(defaultValue, field.name, [], false);
    }
    var eventName: any =
      _.startCase(_.camelCase(field.name)).split(" ").join("") + "Events";

    var instancedClass: any = {};
    var onEvents: any = {};
    if (field.password && defaultValue === undefined && this.props.isEdit) {
      defaultValue = "";
    }

    var errors = [];
    if (field.label === undefined) {
      errors.push("Esse campo não possui label!");
    }
    if (field.name.includes("fk") && field.type !== "select") {
      errors.push(
        "Esse campo possui FK (" +
        field.name +
        ") mas é do tipo " +
        field.type +
        "!"
      );
    }
    if (
      field.name.includes(
        this.props.form.$GLOBALS.prefix + "_" + this.props.form.$GLOBALS.prefix
      ) &&
      field.type !== "checktreepicker"
    ) {
      errors.push(
        "Esse campo possui o nome duplicado (" +
        field.name +
        "), isso irá causar problemas nas colunas futuramente!"
      );
    }
    if (
      field.type === "select" &&
      field.api === undefined &&
      field.options === undefined
    ) {
      errors.push("Esse campo é do tipo SELECT e não possui API nem OPTIONS!");
    }
    if (
      field.type === "select" &&
      !field.name.includes("fk") &&
      field.api !== undefined
    ) {
      errors.push(
        "Esse campo é do tipo SELECT mas não possui FK no nome, isso fará com que o relacionamento deste campo não funcione corretamente!"
      );
    }
    if (field.type === "grid" && field.api === undefined) {
      errors.push("Esse campo é do tipo GRID mas não possui API");
    }

    if (this.state.loadings.includes(field.name)) {
      return (
        <Form.Group key={index} className={classNames("col-md-" + field.width)}>
          <Form.ControlLabel>
            <div
              dangerouslySetInnerHTML={{
                __html: field.label ? field.label : field.name,
              }}
            ></div>
          </Form.ControlLabel>
          <Placeholder.Paragraph rows={2} rowMargin={8}></Placeholder.Paragraph>
        </Form.Group>
      );
    }

    var renderError: any = (
      <ErrorPopover errors={errors} title="Esse campo não possui label!" />
    );
    try {
      if (Events) {
        var eventList: any = Events;
        var event: any = eventList[eventName];

        if (event) {
          instancedClass = new event(
            field.name,
            this.state,
            this.setStateProperty,
            this.setFieldState,
            this.setExternalFieldValue,
            this.setFieldProperty,
            this.props.history.route,
            this.props.history.match,
            this.props
          );
          for (let i in instancedClass) {
            if (i === "render") {
              onEvents[i] = instancedClass[i];
            }

            if (
              i !== "render" &&
              i !== "callback" &&
              i !== "setGlobalState" &&
              i !== "setState" &&
              i !== "setValue" &&
              i !== "setProperties"
            ) {
              onEvents[i] = (value: any, ...props: any) => {
                var output = instancedClass[i](
                  value,
                  this.setExternalFieldValue,
                  this.setStateProperty,
                  this.props.parentValues ?? this.state.formValues,
                  ...props
                );

                if (output) {
                  return output;
                }
              };
            }
          }
        }
        const genericClass = this.genericEventHandler;
        for (let i in genericClass.onEvents) {
          if (!onEvents[i]) {
            let output = this.checkGenericEvent(i, field.name);
            if (output) {
              onEvents[i] = (value: any, ...props: any) => {
                if (output) {
                  output(value);
                  return output;
                }
              };
            }
          }
        }
      }
    } catch (ex) { }
    var formOverrides: any = {};
    if (onEvents["overrideConditions"]) {
      formOverrides = onEvents["overrideConditions"](field);
    }
    var outputHtmlField = null;

    try {
      switch (type) {
        case "custom":
          var componentList: any = CustomComponents;
          var builtComponent: any = null;
          if (componentList[field.component]) {
            builtComponent = componentList[field.component];

            outputHtmlField = (
              <Form.Group>
                {/* <ControlLabel>
                                <div dangerouslySetInnerHTML={{ __html: (field.label ? field.label : field.name) + (field.description ?? "") }}></div>
                            </ControlLabel> */}
                {React.createElement(builtComponent, {
                  ...this.props,
                  ...field,
                  field: { ...field },
                  error: this.renderError(field.name),
                  customValues: this.state.formValues[field.name]
                    ? this.state.formValues[field.name]
                    : undefined,
                  guid: this.guid,
                  parent: this.props.parent,
                  relation: this.props.form.$GLOBALS.table,
                  onChange: (value: boolean) => {
                    this.onChangeInput(value, field.name);
                    if (onEvents["onChange"]) {
                      onEvents["onChange"](value);
                    }
                  },
                }) ?? "Oops..."}
              </Form.Group>
            );
          }
          break;
        case "checkbox":
          var valueFieldCheck =
            field.checkedType !== undefined ? field.checkedType : oldValue;
          outputHtmlField = (
            <Form.Group className={classNames("checkbox")}>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
              </Form.ControlLabel>
              <Toggle
                {...onEvents}
                defaultChecked={oldValue ? oldValue : defaultValue}
                checked={valueFieldCheck ? valueFieldCheck : defaultValue}
                disabled={field.readonly || field.disabled}
                onChange={(value: boolean) => {
                  this.onChangeInput(value, field.name);
                  if (onEvents["onChange"]) {
                    onEvents["onChange"](value);
                  }
                }}
              ></Toggle>
              {this.renderError(field.name)}
              {field.required && <Form.HelpText>Obrigatório</Form.HelpText>}
            </Form.Group>
          );
          break;
        case "numeric":
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "95%",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        (field.label ? field.label : field.name) +
                        (field.description ?? ""),
                    }}
                  ></div>
                  {field.columnInfo && (
                    <Whisper
                      speaker={
                        <Popover title="Informacão">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: field.columnInfo ? field.columnInfo : "",
                            }}
                          ></div>
                        </Popover>
                      }
                      trigger={"hover"}
                      placement="top"
                    >
                      <i className="fas fa-info-circle"></i>
                    </Whisper>
                  )}
                </div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <div className="rs-form-control-wrapper">
                <NumberInput
                  maxLenght={field.maxlength}
                  leftPadding={field.leftPadding}
                  rightPadding={field.rightPadding}
                  disabled={field.readonly || field.disabled}
                  preffix={field.preffix}
                  suffix={field.suffix}
                  punctuation={field.punctuation}
                  step={field.step}
                  max={field.max}
                  min={field.min}
                  onBlur={(value: any) => {
                    if (onEvents["onBlur"]) {
                      onEvents["onBlur"](value);
                    }
                  }}
                  value={this.state.formValues[field.name] ?? undefined}
                  onChange={(value: string) =>
                    this.onChangeInput(value, field.name)
                  }
                />
                {this.renderError(field.name)}
              </div>
              {field.required && <Form.HelpText>Obrigatório</Form.HelpText>}
            </Form.Group>
          );
          break;
        case "datepicker":
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <div className="rs-form-control-wrapper">
                <DatePickerComponent
                  value={this.state.formValues[field.name] ?? ""}
                  onChange={(value: any) => {
                    this.onChangeInput(value, field.name);
                    if (onEvents["onChange"]) {
                      onEvents["onChange"](value);
                    }
                  }}
                  readonly={field.readonly ? true : false}
                />
                {this.renderError(field.name)}
              </div>
              {field.required && <Form.HelpText>Obrigatório</Form.HelpText>}
            </Form.Group>
          );
          break;
        case "text":
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      alignItems: "center",
                    }}
                  >
                    <div
                      dangerouslySetInnerHTML={{
                        __html:
                          (field.label ? field.label : field.name) +
                          (field.description ?? ""),
                      }}
                    ></div>
                    {field.password === true &&
                      this.props.isEdit &&
                      field.name !== "user_salary" ? (
                      <small style={{ fontSize: 10, marginLeft: 6 }}>
                        {" "}
                        *deixe em branco caso não deseje trocar a senha.
                      </small>
                    ) : null}
                  </div>
                  {field.columnInfo && (
                    <Whisper
                      speaker={
                        <Popover title="Informacão">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: field.columnInfo ? field.columnInfo : "",
                            }}
                          ></div>
                        </Popover>
                      }
                      trigger={"hover"}
                      placement="top"
                    >
                      <i className="fas fa-info-circle"></i>
                    </Whisper>
                  )}
                </div>
                {renderError}
              </Form.ControlLabel>
              <div className="rs-form-control-wrapper">
                <MaskInput
                  autoFocus={index === this.lowestTextInputIndex}
                  {...onEvents}
                  allowLowercase={field.allowLowercase}
                  disabled={field.readonly || field.disabled}
                  isEdit={this.props.isEdit}
                  password={
                    field.password ? field.password.toString() : "false"
                  }
                  password_character={field.password_character}
                  value={
                    this.state.formValues[field.name] && field.password !== true
                      ? this.state.formValues[field.name]
                      : undefined
                  }
                  name={field.name}
                  maxLength={field.maxlength ?? undefined}
                  minLength={field.minlength ?? undefined}
                  preffix={field.preffix}
                  suffix={field.suffix}
                  onChangeEnd={(value: string, e: any) => {
                    this.onChangeInput(value, field.name);
                    if (onEvents["onChange"]) {
                      onEvents["onChange"](value);
                    }
                  }}
                  required={
                    field.password === true && this.props.isEdit
                      ? false
                      : field.required
                  }
                  regex={field.regex}
                  mask={field.disabledMask === true ? undefined : field.mask}
                ></MaskInput>
                {this.renderError(field.name)}
              </div>
              {field.required && <Form.HelpText>Obrigatório</Form.HelpText>}
            </Form.Group>
          );
          break;
        case "select":
          let usesValues: any = {};
          let useSearchValues: any = false;
          if (field.api && field.api.uses) {
            for (let i in field.api.uses) {
              var use = field.api.uses[i];

              if (use.type === "field" && use.field !== field.name) {
                var value = this.state.formValues[use.field];
                if (value !== null) {
                  usesValues[use.as] = value;
                }
              }
              if (use.type === "value") {
                useSearchValues = true;
                value = use.field;

                usesValues[use.as] = value;
              }
            }
          }
          var data: any[] =
            this.state.formData[field.name] &&
              this.state.formData[field.name].options
              ? this.state.formData[field.name].options
              : [];

          var relationName: any = null;
          var displayLabel = (field.browseLabel?.length > 0 ? field.browseLabel : undefined) ?? field.displayLabel;
          if (field.name.includes("fk") && defaultValue !== undefined && defaultValue !== null) {
            relationName = field.name.split("fk_").pop().split("_id").shift();

            if (this.state.oldValues[relationName]) {
              defaultValue =
                this.state.oldValues[relationName][relationName + "_id"];
              if (this.state.oldValues[relationName] && displayLabel) {
                try {
                  var label = displayLabel
                    .split(".")
                    .reduce((o: any, i: any) => o[i], this.state.oldValues);
                  if (label === null) {
                    label = "NOT FOUND";
                  }
                  data = [
                    {
                      value: defaultValue.toString().toLocaleUpperCase(),
                      label,
                    },
                  ];
                } catch (e: any) {
                  data = [{ value: -1, label: "Whoops.." + e.message }];
                  try {
                    const evalued = eval(
                      "var " +
                      relationName +
                      " = JSON.parse('" +
                      JSON.stringify(this.state.oldValues[relationName]) +
                      "');" +
                      displayLabel
                    );
                    data = [
                      {
                        value: defaultValue.toString().toLocaleUpperCase(),
                        label: evalued,
                      },
                    ];
                  } catch (e) {
                    throw Error(
                      "Não foi possivel encontrar o caminho de " + displayLabel
                    );
                  }
                }
              }
            }
          }
          var cachedData = _.map(
            this.state.cachedData[field.name]
              ? this.state.cachedData[field.name]
              : [],
            (item) => {
              item.value = item.value.toString().toLocaleUpperCase();
              return item;
            }
          );

          var finalValue = oldValue ? oldValue : defaultValue;
          if (finalValue) {
            finalValue = finalValue.toString().toLocaleUpperCase();
          }
          if (finalValue === null) {
            cachedData = [];
          }
          const availableOptions = _.map(
            [...data, ...cachedData],
            (item: any) => {
              item.value = item.value.toString().toLocaleUpperCase();
              item.label = item.label.toString().toLocaleUpperCase();
              return item;
            }
          );

          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    justifyContent: "space-between",
                    width: "95%",
                  }}
                >
                  <div
                    dangerouslySetInnerHTML={{
                      __html:
                        (field.label ? field.label : field.name) +
                        (field.description ?? ""),
                    }}
                  ></div>
                  {field.columnInfo && (
                    <Whisper
                      speaker={
                        <Popover title="Informacão">
                          <div
                            dangerouslySetInnerHTML={{
                              __html: field.columnInfo ? field.columnInfo : "",
                            }}
                          ></div>
                        </Popover>
                      }
                      trigger={"hover"}
                      placement="top"
                    >
                      <i className="fas fa-info-circle"></i>
                    </Whisper>
                  )}
                </div>
                {renderError}
              </Form.ControlLabel>
              <div className="rs-form-control-wrapper">
                <AxiosSelectPicker
                  {...field}
                  readOnly={field.readonly}
                  disabled={field.disabled}
                  defaultValue={finalValue}
                  value={this.state.formValues[field.name]}
                  isEdit={this.props.isEdit}
                  canEdit={field.canEdit}
                  onFirstLoad={(data: any) => {
                    this.setState((oldState: any) => {
                      var cachedData = { ...oldState.cachedData };
                      cachedData[field.name] = data;
                      return { cachedData };
                    });
                  }}
                  onChange={(value: string, e: any) => {
                    this.onChangeInput(
                      value ? value.toString() : value,
                      field.name,
                      e
                    );

                    if (onEvents["onChange"]) {
                      onEvents["onChange"](value ? value.toString() : value);
                    }
                    if (onEvents["onChangeSelect"]) {
                      onEvents["onChangeSelect"](e);
                    }
                  }}
                  advanced={field.advancedSearch ?? undefined}
                  advancedInclude={field.advancedInclude ?? undefined}
                  searchable={field.searchable ?? undefined}
                  uses={usesValues}
                  searchValue={useSearchValues}
                  shortcut={field.shortcut ?? undefined}
                  displayLabel={field.displayLabel ?? undefined}
                  api={field.api ? field.api : undefined}
                  useActive={field?.useActive ? field?.useActive : undefined}
                  options={field.options ? field.options : undefined}
                  placeholder={"Selecione..."}
                  data={availableOptions}
                ></AxiosSelectPicker>
                {this.renderError(field.name)}
              </div>
              {/* <div style={{whiteSpace:"normal",wordBreak:"break-all"}}>
                            {JSON.stringify(this.state.formValues[relationName])} <br />
                            - {diplayLabel}

                            </div> */}

              {field.required && <Form.HelpText>Obrigatório</Form.HelpText>}
            </Form.Group>
          );
          break;
        case "divider":
          outputHtmlField = (
            <Divider key={index}>
              <h4>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {renderError}
              </h4>
            </Divider>
          );
          break;
        case "grid":
          if (!field.api) {
            outputHtmlField = (
              <div style={{ display: "flex" }}>Oops... {renderError}</div>
            );
          } else {
            outputHtmlField = (
              <Form.Group key={index}>
                <div className="rs-form-control-wrapper">
                  { }
                  <Grid
                    {...onEvents}
                    name={field.name}
                    parentValues={this.state.formValues}
                    parent={this.props.form}
                    inline={field.inline === true}
                    values={_.cloneDeep(oldValue ? oldValue : defaultValue)}
                    canAdd={field.gridAdd === true}
                    canDelete={field.gridDelete === true}
                    label={field.label}
                    formOverrides={formOverrides}
                    canEdit={field.gridEdit === true}
                    globals={this.props.form.$GLOBALS}
                    readOnly={this.props.readOnly}
                    draggable={field.draggable}
                    compact={field.compact}
                    onChange={(value: any, cache: any) => {
                      this.onChangeInput(value, field.name, cache);
                      if (onEvents["onChange"]) {
                        onEvents["onChange"](value);
                      }
                    }}
                    actions={(rowData: any) => {
                      if (onEvents["actions"]) {
                        return onEvents["actions"](rowData);
                      }
                    }}
                    onAdd={(value: any, index: any) => {
                      if (onEvents["onAdd"]) {
                        onEvents["onAdd"](value, index);
                      }
                    }}
                    onEdit={(value: any, index: any) => {
                      if (onEvents["onEdit"]) {
                        onEvents["onEdit"](value, index);
                      }
                    }}
                    onDelete={(value: any, index: any) => {
                      if (onEvents["onDelete"]) {
                        onEvents["onDelete"](value, index);
                      }
                    }}
                    history={this.props.history}
                    field={field}
                  />
                  {this.renderError(field.name)}
                </div>
              </Form.Group>
            );
          }
          break;
        case "color":
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <ColorPicker
                value={oldValue ? oldValue : defaultValue}
                onChange={(value: any, e: any) =>
                  this.onChangeInput(value, field.name)
                }
              />
              {this.renderError(field.name)}
            </Form.Group>
          );
          break;
        case "daypicker":
          var oldDayValues = [];
          for (var dayIndex = 1; dayIndex <= 31; dayIndex++) {
            const fieldName = field.name + "_day" + dayIndex;
            if (this.state.formValues[fieldName] === true) {
              oldDayValues.push(dayIndex);
            }
          }
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <DayPicker
                values={oldDayValues}
                days={31}
                onChange={(values: any) => {
                  for (var i = 1; i <= 31; i++) {
                    this.onChangeInput(
                      values.includes(i),
                      field.name + "_day" + i
                    );
                  }
                }}
              />
              { }
            </Form.Group>
          );
          break;
        case "checktreepicker":
          var parsedValue: any = [];
          let usesValuesCheck: any = {};
          let useSearchValuesCheck: any = false;
          if (field.api && field.api.uses) {
            for (let i in field.api.uses) {
              var use = field.api.uses[i];

              if (use.type === "field" && use.field !== field.name) {
                var value = this.state.formValues[use.field];
                if (value !== null) {
                  usesValuesCheck[use.as] = value;
                }
              }
              if (use.type === "value") {
                useSearchValuesCheck = true;
                value = use.field;

                usesValuesCheck[use.as] = value;
              }
            }
          }
          if (oldValue ? oldValue : defaultValue !== undefined) {
            parsedValue = _.uniq(
              (oldValue ? oldValue : defaultValue).map((item: any) => {
                if (item[pluralize.singular(field.name) + "_value"]) {
                  return item[pluralize.singular(field.name) + "_value"];
                } else {
                  return item ?? undefined;
                }
              })
            );
          }
          var cachedData = _.map(
            this.state.cachedData[field.name]
              ? this.state.cachedData[field.name]
              : [],
            (item) => {
              return item;
            }
          );

          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <div className="rs-form-control-wrapper">
                <CheckTreePicker
                  api={field.api ? field.api : undefined}
                  disabled={field.disabled}
                  options={field.options ? field.options : undefined}
                  value={parsedValue}
                  data={cachedData}
                  uses={usesValuesCheck}
                  useActive={field?.useActive ? field?.useActive : undefined}
                  onChange={(value: any, e: any) => {
                    this.onChangeInput(value, field.name, e);
                    if (onEvents["onChange"]) {
                      onEvents["onChange"](value ? value.toString() : value);
                    }
                  }}
                  actions={(rowData: any) => {
                    if (onEvents["actions"]) {
                      return onEvents["actions"](rowData);
                    }
                  }}
                  displayLabel={field.displayLabel ?? undefined}
                />
                {this.renderError(field.name)}
              </div>
              {field.required && <Form.HelpText>Obrigatório</Form.HelpText>}
            </Form.Group>
          );
          break;
        case "list":
          var listRelationName = field.name.split("_").pop();
          if (this.state.oldValues[listRelationName] && field.displayLabel) {
            try {
              var values = [];
              for (var i in this.state.oldValues[listRelationName]) {
                label = field.displayLabel
                  .split(listRelationName + ".")
                  .join("")
                  .split(".")
                  .reduce(
                    (o: any, i: any) => o[i],
                    this.state.oldValues[listRelationName][i]
                  );
                values.push(label);
              }
              if (label === null) {
                label = "NOT FOUND";
              }
              oldValue = values;
            } catch (e) { }
          }
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <ListInput
                value={oldValue ? oldValue : defaultValue}
                onChange={(value: any, e: any) =>
                  this.onChangeInput(value, field.name)
                }
                api={field.api ? field.api : undefined}
                options={field.options ? field.options : undefined}
              />
              {this.renderError(field.name)}
            </Form.Group>
          );
          break;
        case "treepicker":
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <DynamicTree />
              {this.renderError(field.name)}
            </Form.Group>
          );
          break;
        case "cascadepicker":
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <AxiosCascadePicker
                value={this.state.formValues[field.name] ?? []}
                onChange={(value: any, e: any) =>
                  this.onChangeInput(value, field.name)
                }
                field={field}
                disabled={field.disabled}
              />
              {this.renderError(field.name)}
              { }
            </Form.Group>
          );
          break;
        case "richtextbox":
          let valueRickText = this.state.formValues[field.name];

          if (valueRickText === null) {
            valueRickText = "";
          }

          // valueRickText = valueRickText.replace("<P>", "");
          // valueRickText = valueRickText.replace("</P>", "");

          if (valueRickText !== null && valueRickText !== undefined) {
            if (valueRickText) {
              var newValueRickText = valueRickText;
            }
          }

          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              <div className="rs-form-control-wrapper">
                <WYSIWYG
                  value={
                    newValueRickText
                      ? newValueRickText
                      : this.state.formValues[field.name]
                  }
                  onChange={(value: any) =>
                    this.onChangeInput(value, field.name)
                  }
                  readOnly={field.readonly}
                />
                {this.renderError(field.name)}
              </div>
              {field.required && <Form.HelpText>Obrigatório</Form.HelpText>}
            </Form.Group>
          );
          break;
        case "file":
          outputHtmlField = (
            <Form.Group>
              <Form.ControlLabel>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      (field.label ? field.label : field.name) +
                      (field.description ?? ""),
                  }}
                ></div>
                {field.password === true && this.props.isEdit ? (
                  <small style={{ fontSize: 10, marginLeft: 6 }}>
                    {" "}
                    deixe em branco caso não deseje trocar a senha.
                  </small>
                ) : null}
                {renderError}
              </Form.ControlLabel>
              { }
              <FileInput
                onBeforeUpload={(value: any) => {
                  if (onEvents["onBeforeUpload"]) {
                    onEvents["onBeforeUpload"](value);
                  }
                }}
                multiple={field.multifiles === true ? field.multifiles : false}
                showQuestions={field.showQuestions === true ? true : false}
                readonly={field.readonly === true ? true : false}
                value={oldValue ? oldValue : defaultValue}
                onChange={(value: any) => this.onChangeInput(value, field.name)}
                guid={this.guid}
                name={field.name}
                relation={this.props.form.$GLOBALS.table}
              />
              {/* <hr />
                            <div>
                            {JSON.stringify(this.state.formValues[field.name])}
                            </div> */}
              {this.renderError(field.name)}
            </Form.Group>
          );
          break;
      }
    } catch (e: any) {
      console.error(e);
      return (
        <div
          id={field.name}
          className={classNames(
            "col-" + field.width,
            "col-xs-12",
            "col-sm-" + field.width
          )}
          key={index}
        >
          <Form.Group>
            <Form.ControlLabel>
              <div
                dangerouslySetInnerHTML={{
                  __html:
                    (field.label ? field.label : field.name) +
                    (field.description ?? ""),
                }}
              ></div>
            </Form.ControlLabel>
            <Message
              type={"error"}
              description={e.message + " - " + e}
            ></Message>
          </Form.Group>
        </div>
      );
    }

    /*{this.state.debugMode === true && <Message type={"info"} description={JSON.stringify(this.state.formValues[field.name])}></Message>}
                {this.state.debugMode === true && <Message className="rs-scrollable" type={"warning"} description={field.name}></Message>}
                {this.state.debugMode === true && <Message className="rs-scrollable" type={"success"} description={eventName}></Message>}
                {this.state.debugMode === true && <Message className="rs-scrollable" type={"info"} description={JSON.stringify(field.disabled)}></Message>}*/
    return (
      <div
        id={field.name}
        className={classNames(
          "p-rel",
          "col-" + field.width,
          "col-xs-12",
          "col-sm-" + field.width
        )}
        style={{ display: hidden === true ? "none" : "block" }}
        key={index}
      >
        {outputHtmlField}
        {onEvents["onRender"]
          ? onEvents["onRender"](this.state.fieldStates[field.name] ?? {})
          : null}
        {this.state.debugMode === true && (
          <Message className="rs-scrollable" type={"success"}>
            {eventName}
          </Message>
        )}
        {this.state.debugMode === true && (
          <Message type={"info"}>
            {JSON.stringify(this.state.formValues[field.name])}
          </Message>
        )}
      </div>
    );
  };

  onSubmit = (callback: Function | any = () => { }, errorCallback: Function | any = () => { }) => {
    try {
      var errors: any = {};
      var passwords: string[] = [];
      var hasRequiredInTheSameTab = false;
      const activeFormData = { ...this.props.form, ...this.state.formData };

      for (let i in activeFormData) {
        var field = activeFormData[i];
        if (!field.name) continue;
        if (field.canAdd === false && this.props.isEdit === false) {
          continue;
        }
        if (field.readOnly) {
          continue;
        }
        if (field.password === true) {
        } else {
          if (
            activeFormData[i].hidden !== true &&
            activeFormData[i].disabled !== true
          ) {
            if (activeFormData[i].required) {
              if (
                (this.state.formValues[i] === undefined ||
                  this.state.formValues[i] === null) &&
                this.state.oldValues[i] === undefined &&
                field.hidden !== true &&
                field.disabled !== true
              ) {
                errors[i] = "Campo obrigatório!";
              } else {
                if (typeof this.state.formValues[i] === "string") {
                  if (this.state.formValues[i].length <= 0) {
                    errors[i] = "Campo obrigatório!";
                  }
                } else {
                  if (typeof this.state.formValues[i] === "number") {
                    if (
                      this.state.formValues[i] === undefined ||
                      this.state.formValues[i] === null
                    ) {
                      errors[i] = "Campo obrigatório!";
                    }
                    if (
                      activeFormData[i]?.min > 0 &&
                      this.state.formValues[i] <= 0
                    ) {
                      errors[i] = "Coloque um número maior que zero!";
                    }
                  } else if (_.isArray(this.state.formValues[i])) {
                    if (this.state.formValues[i].length <= 0) {
                      errors[i] = "Campo obrigatório!";
                    }
                  } else {
                    errors[i] = "Campo obrigatório!";
                  }
                }
              }
            }
          }
        }
      }

      let output: any = {};
      for (let i in this.state.oldValues) {
        if (this.props.name) {
          var id = i.includes(pluralize.singular(this.props.name) + "_id");
        } else {
          id = false;
        }
        if (
          this.state.oldValues[i] !== undefined &&
          (Object.keys(this.props.form).includes(i) || i.includes("_day") || id)
        ) {
          output[i] = this.state.oldValues[i];
        }
      }

      for (let i in this.state.formValues) {
        if (
          this.state.formValues[i] !== undefined &&
          (Object.keys(this.props.form).includes(i) || i.includes("_day"))
        ) {
          output[i] = this.state.formValues[i];
        }
      }

      for (let i in passwords) {
        delete output[passwords[i]];
      }
      for (let i in errors) {
        if (
          this.props.form[i].tabs &&
          this.props.form[i].tabs.includes(this.state.activeTab)
        ) {
          hasRequiredInTheSameTab = true;

          break;
        }
      }

      this.setState({ errors, resultValues: output });
      var lowestTabIndex = 9999;
      var lowestTab = null;
      const tabsIndex = _.map(this.props.form.$GLOBALS.tabs ?? {}, (item) => {
        return item.key;
      });

      if (errors) {
        var firstField = Object.keys(errors)[0];
        if (firstField) {
          var field = this.props.form[firstField];
          var tabs = field.tabs;
          if (tabs && field.type !== "grid") {
            var firstTab = tabs[0];
            if (firstTab) {
              if (lowestTabIndex > tabsIndex.indexOf(firstTab)) {
                lowestTabIndex = tabsIndex.indexOf(firstTab);
                lowestTab = firstTab;
              }
            }
          }
        }
      }

      if (lowestTab && hasRequiredInTheSameTab === false) {
        this.selectTab(lowestTab);
      }
      if (Object.keys(errors).length === 0 && this.props.onSubmit) {
        if (!output["guid"]) {
          output["guid"] = this.guid;
        }
        const primaryKey = this.props.form.$GLOBALS.prefix + "_id";
        this.setState({ isLoading: true });
        for (var i in output) {
          if (typeof output[i] === "object" && output[i]?.value) {
            output[i] = output[i].value;
          }
        }

        axios
          .post("/api/v1/" + this.state.crud + "/validate", {
            id: this.state.formValues[primaryKey] ?? this.guid,
            data: output,
            parent: this.props.parentValues ?? undefined,
            particularitieAdd: this.state.crud === 'client_particularities' ? particularitieAdd : false,
            particularitieEdit: this.state.crud === 'client_particularities' ? particularitieEdit : false,
            method: this.state.crud === 'client_particularities' ? this.method : ""
          })
          .then((res) => {
            if (res && res.data && Object.keys(res.data.errors).length > 0) {
              const errors: any = {};
              const alertErrors: any = [];

              if (_.isObject(res.data.errors) && _.isArray(res.data.errors) === false) {
                for (const field in res.data.errors) {
                  errors[field] = res.data.errors[field];
                }
              } else {
                for (const error of res.data.errors) {
                  if (typeof error === "object") {
                    errors[error.field] = error.text;
                  } else {
                    alertErrors.push(error);
                  }
                }
              }

              if (this.state.crud === "boxes") {
                let labels: string = "";
                for (const item of alertErrors) {
                  labels += `> ${item}, `;
                }
                labels = labels.slice(0, -2);
                iziToast.error({
                  title: "Campos obrigatórios para avançar situação!",
                  message: labels,
                  position: "topRight",
                  timeout: 600000,
                  close: true,
                });

                this.setState({ loading: false });
              } else {
                for (var i in alertErrors) {
                  iziToast.error({
                    title: "Erro!",
                    message: alertErrors[i],
                    position: "topRight",
                    timeout: 9000,
                    close: true,
                  });

                }
              }

              this.setState({ errors }, () => {
                try {
                  if (
                    _.isObject(res.data.errors) &&
                    _.isArray(res.data.errors) === false
                  ) {
                    var lowestTabIndex = 9999;
                    var lowestTab = null;
                    if (errors) {
                      var firstField = Object.keys(errors)[0];
                      if (firstField) {
                        var field = this.props.form[firstField];
                        var tabs = field.tabs;
                        if (tabs && field.type !== "grid") {
                          var firstTab = tabs[0];
                          if (firstTab) {
                            if (lowestTabIndex > tabsIndex.indexOf(firstTab)) {
                              lowestTabIndex = tabsIndex.indexOf(firstTab);
                              lowestTab = firstTab;
                            }
                          }
                        }
                      }
                    }
                    this.selectTab(lowestTab, () => { });
                  }
                } catch (e) { }
              });
            } else {
              if (this.props.onSubmit) {
                if (this.props.addCallback) {
                  this.props.addCallback(callback, errorCallback);
                }
                this.props.onSubmit(output, this.guid, this.state.cachedData);
              }
            }
          })
          .catch((res) => {
            console.error(res);
            if (this.props.onSubmit) {
              if (this.props.addCallback) {
                this.props.addCallback(callback, errorCallback);
              }
              this.props.onSubmit(output, this.guid, this.state.cachedData);
            }
          })
          .finally(() => {
            this.setState({ isLoading: false });
          });
      }
    } catch (e) {
      console.log("Error :::> ", e);
    }
  };

  public method: "edit" | "add" | "read" = this.props.isEdit ? "edit" : this.props.readOnly ? "read" : "add";

  renderSubmitButton = () => {
    if (this.props.readOnly === true) {
      if (!this.props.isModal) {
        return null;
      }
    }
    if (this.props.submitButton !== undefined) {
      return this.props.submitButton(this.onSubmit);
    }

    let prefixForm: string = this.props.form.$GLOBALS.table === "dibis" ? "dibi" : this.props.form.$GLOBALS.prefix;
    const customFooterEventsName = _.upperFirst(_.camelCase(prefixForm + "FooterEvents"));
    const events: any = Events;
    const event = events[customFooterEventsName];
    var instancedClass: any = null;
    if (event) {
      instancedClass = new event(
        this.method + "_footer",
        this.state,
        this.setStateProperty,
        this.setFieldState,
        this.setExternalFieldValue
      );
    }

    const eventName = _.upperFirst(pluralize.singular(_.camelCase(this.state.crud))) + "Events";
    const eventHolder: any = Events;
    var showSave = true;

    if (eventHolder[eventName]) {
      const event = eventHolder[eventName];
      const instancedEvent = new event(
        null,
        this.state,
        this.setStateProperty,
        this.setFieldState,
        this.setExternalFieldValue,
        this.setFieldProperty,
        this.props.history,
        this.props.match,
        this.props
      );

      if (instancedEvent["settings"]) {
        showSave = instancedEvent["settings"]["saveButton"] ?? true;
      }
    }

    let paramnsCrud = this.props.match.params.crud;

    if (paramnsCrud.includes("-")) {
      paramnsCrud = paramnsCrud.split("-").join("_");
    }

    return (
      <div className="col-md-12 mt-4 d-flex" style={{ marginBottom: 10 }}>
        {this.props.location.pathname !==
          "/dashboard/configuracoes/developments" &&
          !this.props.location.pathname.includes("transfer_requests") &&
          !this.props.location.pathname.includes("reports") &&
          !this.props.location.pathname.includes("roles") &&
          !this.props.location.pathname.includes("functions") &&
          !this.props.location.pathname.includes("users") && (
            <>
              {(showSave === true || this.method === "add") && (
                <>
                  <Permission name={paramnsCrud + "-browse"}>
                    <Button color="green" onClick={this.onSubmit}>
                      <i className="fas fa-fw fa-save mr-2"></i>
                      Gravar
                    </Button>
                  </Permission>
                </>
              )}
            </>
          )}

        {this.props.location.pathname !==
          "/dashboard/configuracoes/developments" &&
          !this.props.location.pathname.includes("transfer_requests") &&
          !this.props.location.pathname.includes("reports") &&
          !this.props.location.pathname.includes("roles") &&
          this.props.location.pathname.includes("users") &&
          (showSave === true || this.method === "add") && (
            <Permission name={`${paramnsCrud}-browse`}>
              <Button color="green" onClick={this.onSubmit}>
                <i className="fas fa-fw fa-save mr-2"></i>
                Gravar
              </Button>
            </Permission>
          )}
        {this.props.location.pathname !== "/dashboard/configuracoes/developments" &&
          !this.props.location.pathname.includes("transfer_requests") &&
          !this.props.location.pathname.includes("reports") &&
          !this.props.location.pathname.includes("roles") &&
          this.props.location.pathname.includes("function") && (
            <>
              {(showSave === true || this.method === "add") && (
                <>
                  <Permission name={paramnsCrud + "-browse"}>
                    {(this.context as any).data?.user_id === UserPermission.USER_MASTER_NEC || (this.props.values.function_active === true && (
                      <>
                        <Button color="green" onClick={this.onSubmit}>
                          <i className="fas fa-fw fa-save mr-2"></i>
                          Gravar
                        </Button>
                      </>
                    ))}
                  </Permission>
                </>
              )}
            </>
          )}

        {this.props.location.pathname !== "/dashboard/configuracoes/developments" &&
          !this.props.location.pathname.includes("transfer_requests") &&
          !this.props.location.pathname.includes("reports") &&
          this.props.location.pathname.includes("roles") && (
            <>
              {(showSave === true || this.method === "add") && (
                <>
                  <Permission name={paramnsCrud + "-browse"}>
                    {(this.context as any).data?.user_id === UserPermission.USER_MASTER_NEC && (
                      <>
                        <Button color="green" onClick={this.onSubmit}>
                          <i className="fas fa-fw fa-save mr-2"></i>
                          Gravar
                        </Button>
                      </>
                    )}

                    {(this.context as any).data?.user_id !== UserPermission.USER_MASTER_NEC &&
                      (this.context as any).data?.role?.role_id !== RolePermissions.MASTER && (
                        <>
                          <Button color="green" onClick={this.onSubmit}>
                            <i className="fas fa-fw fa-save mr-2"></i>
                            Gravar
                          </Button>
                        </>
                      )}
                  </Permission>
                </>
              )}
            </>
          )}


        {this.method === "edit"
          ? instancedClass
            ? instancedClass["onRenderEditFooter"]
              ? instancedClass["onRenderEditFooter"](this.onSubmit)
              : null
            : null
          : null}
        {this.method === "add"
          ? instancedClass
            ? instancedClass["onRenderAddFooter"]
              ? instancedClass["onRenderAddFooter"](this.onSubmit)
              : null
            : null
          : null}
        {this.method === "read"
          ? instancedClass
            ? instancedClass["onRenderReadFooter"]
              ? instancedClass["onRenderReadFooter"](this.onSubmit)
              : null
            : null
          : null}
        {!this.props.location.pathname.includes("graphics") &&
          !this.props.location.pathname.includes("reports") &&
          !this.props.location.pathname.includes("integration") && (
            <>
              <Permission name="debug">
                <Button
                  color={this.state.debugMode ? "violet" : undefined}
                  onClick={() =>
                    this.setState({ debugMode: !this.state.debugMode })
                  }
                  className="ml-4"
                >
                  <i className="fas fa-fw fa-bug"></i>{" "}
                  {this.state.debugMode ? "Desativar" : "Ativar"} DEBUG
                </Button>
              </Permission>
            </>
          )}
      </div>
    );
  };
  uuidv4() {
    return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function (c) {
        var r = (Math.random() * 16) | 0,
          v = c === "x" ? r : (r & 0x3) | 0x8;
        return v.toString(16);
      }
    );
  }

  public guid = this.props.values?.guid ?? this.uuidv4();

  selectTab = async (activeTab: string, callback: any = function () { }) => {
    this.setState({ activeTab }, callback);
    if (
      this.props.match.params.crud.includes("labs") ||
      this.props.match.params.crud.includes("layout_")
    ) {
      var { tabsLoaded } = this.state;
      if (this.props.match.params.id) {
        const checkTab = await this.props.onCheckTab(activeTab);
        if (checkTab) {
          this.setState({ isLoading: true });
          axios
            .get(
              "/api/v1/" +
              this.props.form.$GLOBALS.table +
              "/" +
              this.props.match.params.id +
              "?tab=" +
              activeTab
            )
            .then((res) => {
              const data = res.data.item;
              for (var i in data) {
                this.setState({
                  formValues: {
                    ...this.props.values,
                    ...this.state.formValues,
                    [i]: data[i],
                    guid: this.guid,
                  },
                });
              }
              this.props.onChangeTab(this.state?.formValues);
            })
            .catch((e) => { })
            .finally(() => {
              this.setState({ isLoading: false });
            });
        } else {
          this.setState({ isLoading: false });
        }
        tabsLoaded.push(activeTab);
      }
    }

    this.props.history.replace(
      this.props.history.location.pathname +
      "?" +
      qs.stringify({ tab: activeTab })
    );
  };

  renderTabs = () => {
    const activeForm = { ...this.props.form, ...this.state.formData };

    const tabs = activeForm.$GLOBALS ? activeForm.$GLOBALS.tabs : [];
    if (
      (tabs?.length <= 0 && this.state.customTabs?.length <= 0) ||
      tabs === undefined
    ) {
      return (
        <Panel
          style={{ background: "white", width: "100%", overflow: "visible" }}
          bordered
        >
          {this.renderContent()}
        </Panel>
      );
    } else {
      const steps = [];

      for (let i in tabs) {
        if (
          this.state.totalFieldsPerTab[tabs[i].key] &&
          this.state.totalFieldsPerTab[tabs[i].key].length > 0
        ) {
          steps.push(
            <Nav.Item
              onSelect={() => this.selectTab(tabs[i].key)}
              eventKey={tabs[i].key}
              key={i}
            >
              {tabs[i].label}
            </Nav.Item>
          );
        }
      }
      for (let i in this.state.customTabs) {
        const customTab = this.state.customTabs[i];

        steps.push(
          <Nav.Item
            onSelect={() => this.selectTab(customTab.key)}
            eventKey={customTab.key}
            key={i}
          >
            {customTab.label}
          </Nav.Item>
        );
      }
      return (
        <>
          <Nav
            className="col-md-12"
            appearance="tabs"
            activeKey={this.state.activeTab}
          >
            {steps}
          </Nav>
          <Panel style={{ background: "white", width: "100%" }} bordered>
            {this.renderContent()}
          </Panel>
        </>
      );
    }
  };

  backToTop = () => {
    window.scrollTo(0, 0);
  };

  renderContent() {
    if (this.state.isLoading === true) {
      return <Placeholder.Paragraph></Placeholder.Paragraph>;
    }
    const GLOBALS = this.props.form.$GLOBALS;
    if (!GLOBALS) {
      return <Placeholder.Paragraph></Placeholder.Paragraph>;
    }
    try {
      if (this.props.isModal) {
        return (
          <form
            className="rs-form rs-form-vertical rs-form-fixed-width"
            autoComplete={"false"}
          >
            <Modal.Header closeButton={false} className="mb-4">
              <h3> {GLOBALS.singular_name ?? "Sem titulo"}</h3>
            </Modal.Header>
            <Modal.Body className="container m-0">
              <fieldset disabled={this.props.readOnly === true} className="row">
                {/* <input id="username" type="text" name="fakeusernameremembered" style={{ display: "none" }} />
                                <input id="password" type="password" name="fakepasswordremembered" style={{ display: "none" }} /> */}
                {this.renderFields()}
              </fieldset>
            </Modal.Body>
            <Modal.Footer className="mt-4">
              {this.renderSubmitButton()}
            </Modal.Footer>
          </form>
        );
      }
      const customTab = _.find(this.state.customTabs ?? [], {
        key: this.state.activeTab,
      });
      const isInCustomTab = customTab !== undefined;
      return (
        <>
          <button onClick={() => this.backToTop()} className="back-to-top">
            <i className="fas fa-angle-double-up"></i>
          </button>
          <form
            className="rs-form rs-form-vertical rs-form-fixed-width"
            autoComplete={"false"}
          >
            <fieldset>
              <div className="row">
                {/* <input id="username" type="text" name="fakeusernameremembered" style={{ display: "none" }} />
                            <input id="password" type="password" name="fakepasswordremembered" style={{ display: "none" }} /> */}
                {isInCustomTab === true && customTab.jsxComponent}
                {isInCustomTab === false && this.renderFields()}

                {this.renderSubmitButton()}
                {this.state.debugMode === true && (
                  <Message
                    type="info"
                    description={JSON.stringify(this.state.formValues)}
                  ></Message>
                )}
              </div>
            </fieldset>
          </form>
        </>
      );
    } catch (e: any) {
      return (
        <div className="row">
          <div className="col-md-12">
            <Message type="error">{e.message}</Message>
          </div>
        </div>
      );
    }
  }

  public starterValues = _.clone(this.props.values);

  filterOnTopFields = () => {
    return _.filter(this.state.formData, { showOnTop: true });
  };

  renderOnTopFields = () => {
    const fields = this.filterOnTopFields();

    const output = _.map(
      _.sortBy(fields, "showOnTopOrder"),
      (item, index: any) => {
        const field = item;

        var value = null;

        if (typeof this.starterValues[item.name] === "string") {
          value = this.starterValues[item.name]?.length
            ? this.starterValues[item.name]
            : "";
        }
        if (typeof this.starterValues[item.name] === "boolean") {
          value = this.starterValues[item.name];
        }

        if (item.type === "select") {
          if (item.options) {
            value =
              _.find(item.options, (listItem) => {
                return (
                  listItem.value === this.starterValues[item.name] ||
                  listItem.value?.toString() ===
                  this.starterValues[item.name]?.toString()
                );
              })?.label ?? "Nenhum";
          } else {
            var relationName: any = null;

            var diplayLabel =
              (field.browseLabel?.length > 0 ? field.browseLabel : undefined) ??
              field.displayLabel;

            if (field.name.includes("fk")) {
              relationName = field.name.split("fk_").pop().split("_id").shift();

              if (this.starterValues[relationName]) {
                if (this.starterValues[relationName] && diplayLabel) {
                  try {
                    var label = diplayLabel
                      .split(".")
                      .reduce((o: any, i: any) => o[i], this.starterValues);

                    if (label === null) {
                      label = "NOT FOUND";
                    }
                    value = label;
                  } catch (e: any) {
                    value = "Whoops.." + e.message;
                  }
                } else {
                  value = "Não existe";
                }
              } else {
                value = "teste";
              }
            }
            value =
              _.find(this.state.cachedData[item.name], {
                value: this.starterValues[item.name]?.toString(),
              })?.label ?? "Nenhum";
          }
        }
        return (
          <div
            key={index}
            className={classNames("col-md-2")}
            style={{ fontSize: "12px" }}
          >
            <Form.ControlLabel>
              <span
                dangerouslySetInnerHTML={{ __html: item?.label ?? item?.name }}
              ></span>
            </Form.ControlLabel>
            {item.type !== "checkbox" && (
              <MaskInput readonly mask={item.mask ?? undefined} value={value} />
            )}
            {item.type === "checkbox" && <Toggle readonly checked={value} />}
            { }
            { }
            { }
            { }
            {/* {JSON.stringify(this.starterValues[item.name])}
                    {JSON.stringify(this.state.cachedData[item.name])} */}
          </div>
        );
      }
    );
    return <div className="row">{output}</div>;
  };

  render() {
    return (
      <>
        {(this.props.isEdit === true || this.props.readOnly === true) &&
          this.filterOnTopFields().length > 0 && (
            <Panel bordered className="on-top rs-no-body mb-4 w-50">
              {this.renderOnTopFields()}
            </Panel>
          )}
        { }

        {this.renderTabs()}
        { }
        { }
        { }
        { }
        {/* <hr />
                {JSON.stringify(this.state.priorityFormData)}
                <hr />
                {JSON.stringify(this.state.formData["developer_string"])} */}
        { }
        { }
        { }
        { }
        { }
        { }
        { }
        { }
      </>
    );
  }
}

export default withRouter(Formalize);
